export const PageContainer = {
  baseStyle: {
    margin: '0px 64px 0px 64px',
    maxWidth: '960px',
  },
  variants: {
    center: {
      margin: '0px auto 0px auto',
    },
  },
};
